






export default {
	props: {
		items: { type: Number, default: 1 },
		animation: { type: String, default: "wave" },
	},

	methods: {
		width(min, max) {
			return Math.floor(Math.random() * (max - min)) + min
		}
	}
}
